<template>
  <div class="d-flex flex-row">
    <div>
      <a :href="`/users/${user.key}`"><avatar :user="user" /></a>
    </div>
    <div class="pl-2 flex-grow-1">
      <div>
        <a :href="`/users/${user.key}`">
          {{ user.name }}
        </a>
        <a :href="`/users/${user.key}/mags/${mag.key}`" v-if="user.key !== 'anonymous'">
          <small style="color: gray;">
            {{ mag.created_at }}
          </small>
        </a>
        <small style="color: gray;" v-else>
          {{ mag.created_at }}
        </small>
      </div>
      <div class="pt-1">
        <template v-if="mag.memo && mag.memo.length > 0">
          <i class="fas fa-lock" style="color: goldenrod" v-if="mag.is_private_memo"></i>
          {{ mag.memo }}
        </template>
        <i v-else>
          {{ mag.time }}セックスしました！
        </i>
      </div>
      <div class="pt-1 d-flex">
        <show-score :value="mag.score" :is-private="mag.is_private_score" v-if="mag.score" />
        <div class="text-right flex-grow-1">
          <a
            v-if="showEdit"
            :href="`/mags/${mag.key}/edit`"
            class="btn btn-sm btn-outline-primary mr-2">
            <i class="fas fa-pen"></i> 編集
          </a>
          <like-button
            :like-count="mag.like_count"
            :mag-key="mag.key"
            :already-liked="alreadyLiked" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShowScore from './_show_score'
import Avatar from '../users/_avatar'
import LikeButton from './_like_button'

export default {
  components: { ShowScore, Avatar, LikeButton },
  props: ['mag', 'user', 'showEdit', 'alreadyLiked'],
  data() {
    return {
      isExistAvatar: true
    }
  },
  mounted() {
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>
</style>
